import { styled, Stack } from '@mui/material';

export const RoutesContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.base.main,
  boxShadow: theme.shadows[3],
}));
